export enum ReclassifyChecksMode {
	PayrollMode = 1,
	FundMode = 2,
}
